import React from 'react';
import { MessageSquare, Zap } from 'lucide-react';
import { ContextualSuggestion } from '@/types/pageContext';
import { Button } from '@/components/ui/button';
import { cn } from '@/lib/utils';

interface ContextualSuggestionsProps {
  suggestions: ContextualSuggestion[];
  onSuggestionClick: (suggestionText: string) => void;
}

export const ContextualSuggestions: React.FC<ContextualSuggestionsProps> = ({
  suggestions,
  onSuggestionClick
}) => {
  if (suggestions.length === 0) return null;

  const handleSuggestionClick = (suggestion: ContextualSuggestion) => {
    onSuggestionClick(suggestion.text);
  };

  return (
    <div className="space-y-3">
      <div className="flex items-center gap-2 text-xs font-medium text-muted-foreground">
        <Zap className="w-3.5 h-3.5" />
        <span>Sugestões para esta página</span>
      </div>
      
      <div className="grid gap-2">
        {suggestions.map((suggestion) => (
          <Button
            key={suggestion.id}
            variant="outline"
            size="sm"
            onClick={() => handleSuggestionClick(suggestion)}
            className={cn(
              "justify-start text-left h-auto p-3 text-xs",
              "hover:bg-primary/5 hover:border-primary/30",
              "transition-all duration-200",
              "whitespace-normal leading-relaxed"
            )}
          >
            <div className="flex items-start gap-2 w-full">
              <MessageSquare className="w-3.5 h-3.5 mt-0.5 flex-shrink-0 text-primary/60" />
              <div className="flex-1">
                <div className="text-foreground">{suggestion.text}</div>
                {suggestion.type === 'action' && (
                  <div className="text-xs text-muted-foreground mt-1 flex items-center gap-1">
                    <Zap className="w-2.5 h-2.5" />
                    <span>Ação rápida</span>
                  </div>
                )}
              </div>
            </div>
          </Button>
        ))}
      </div>

      <div className="text-xs text-muted-foreground text-center">
        Ou digite sua própria pergunta abaixo
      </div>
    </div>
  );
};